export default "__VITE_ASSET__CQOXnsP3__"